/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoomAvailabilityPropertyRequest
 */
export interface RoomAvailabilityPropertyRequest {
    /**
     * 
     * @type {number}
     * @memberof RoomAvailabilityPropertyRequest
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof RoomAvailabilityPropertyRequest
     */
    checkin: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoomAvailabilityPropertyRequest
     */
    checkout: Date;
}

/**
 * Check if a given object implements the RoomAvailabilityPropertyRequest interface.
 */
export function instanceOfRoomAvailabilityPropertyRequest(value: object): value is RoomAvailabilityPropertyRequest {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    return true;
}

export function RoomAvailabilityPropertyRequestFromJSON(json: any): RoomAvailabilityPropertyRequest {
    return RoomAvailabilityPropertyRequestFromJSONTyped(json, false);
}

export function RoomAvailabilityPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomAvailabilityPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'checkin': (new Date(json['checkin'])),
        'checkout': (new Date(json['checkout'])),
    };
}

export function RoomAvailabilityPropertyRequestToJSON(json: any): RoomAvailabilityPropertyRequest {
    return RoomAvailabilityPropertyRequestToJSONTyped(json, false);
}

export function RoomAvailabilityPropertyRequestToJSONTyped(value?: RoomAvailabilityPropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'].toISOString().substring(0,10),
        'checkout': value['checkout'].toISOString().substring(0,10),
    };
}

